import { render } from "./LeadForm.vue?vue&type=template&id=5fc26b1a"
import script from "./LeadForm.vue?vue&type=script&lang=js"
export * from "./LeadForm.vue?vue&type=script&lang=js"

import "./LeadForm.vue?vue&type=style&index=0&id=5fc26b1a&lang=scss"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__